<template>
  <div
    data-testid="hero-report-card"
    class="flex h-full w-full flex-shrink-0 flex-col rounded-lg"
  >
    <div
      class="relative flex flex-grow flex-col justify-between rounded-lg bg-s-100 p-6"
    >
      <CardLabel
        class="absolute left-3 top-3 z-10"
        type="mp4"
        :show-label="report?.show_label"
        :label="cardLabel"
      />

      <div class="absolute left-0 top-0 h-full w-full">
        <img
          data-testid="hero-report-card-image"
          class="h-full w-full rounded-lg object-cover object-center"
          :src="$cloudinary.resize(reportImage, 'hero-video-card')"
          alt=""
        />
        <div
          class="absolute left-0 top-0 h-full w-full rounded-lg bg-black/60"
        ></div>
      </div>
      <div class="z-10 mt-12 text-white">
        <div
          data-testid="hero-report-title"
          class="line-clamp-3 text-xl font-bold"
        >
          {{ reportTitle }}
        </div>
      </div>
      <videoReportCardFooter
        :report="report"
        :product="category"
        :initial-fields="[
          category,
          report?.tags[0]?.name === 'forecast-video'
            ? forecastCheckboxes
            : esgCheckboxes,
        ]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CardLabel from '~/components/portals/CardLabel.vue'
import videoReportCardFooter from '~/components/portals/videoReportCardFooter.vue'
import { FORECASTS, ESG } from '~/constants/services/constants'
import type { TReportProp } from '~/src/types/reports'
import { reformat } from '~/utils/date'
import { useNuxtApp } from '#app'

const props = defineProps<{
  report: TReportProp
  category: string | null
}>()

const { $cloudinary } = useNuxtApp()
const forecastCheckboxes = FORECASTS.checkbox
const esgCheckboxes = ESG.slug

const cardLabel = computed(() => {
  if (!props.report) return null
  return props.report.market_type === 'prices'
    ? reformat(props.report.date, 'dd MMM yyyy')
    : null
})

const reportTitle = computed(() => props.report?.title)
const reportImage = computed(() => props.report?.images?.desktop)
</script>
